import { apiConf, sendRequest } from '../config'

/**
 * 获取网站信息总揽
 */
export const loadWithdrawList = (param) => {
  return sendRequest(apiConf.recordApi.loadWithdrawList, param)
}
/**
 * 获取网站列表
 */
export const getWithdrawStoreList = () => {
    return sendRequest(apiConf.recordApi.getWithdrawStoreList)
}


/**
 * 获取自提现订单列表
 */
export const loadSelfWithdrawList = (param) => {
  return sendRequest(apiConf.recordApi.loadSelfWithdrawList, param)
}

